import styled, { css } from 'styled-components';

import { LabelSize } from '.';

interface LabelStylesProps {
  $size: LabelSize;
  $highContrast: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: space-between;

  gap: ${({ theme }) => theme.spacing[1]}px;
`;

export const Texto = styled.span<LabelStylesProps>`
  ${({ theme, $size, $highContrast }) => {
    return css`
      font-size: ${theme.typography.font.size[$size + 1]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.semibold};
      line-height: ${theme.typography.font.line_height[$size + 1]}px;
      text-align: left;
      color: ${$highContrast
        ? theme.tokens.colors.text
        : theme.tokens.colors.text_secondary};
    `;
  }}
`;

export const TextoOpcional = styled.span<LabelStylesProps>`
  ${({ theme, $size, $highContrast }) => {
    return css`
      font-size: ${theme.typography.font.size[$size + 1]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.normal};
      line-height: ${theme.typography.font.line_height[$size + 1]}px;
      text-align: left;
      font-style: italic;
      color: ${$highContrast
        ? theme.tokens.colors.text
        : theme.tokens.colors.text_secondary};
    `;
  }}

  align-self: flex-end;
`;
